import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dBigInt from "../Data.BigInt/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dLazy from "../Data.List.Lazy/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
const sumBy = dictFoldable => dictSemiring => dictFoldable.foldMap((() => {
  const semigroupAdditive1 = {append: v => v1 => dictSemiring.add(v)(v1)};
  return {mempty: dictSemiring.zero, Semigroup0: () => semigroupAdditive1};
})());
const combinations = n => a => {
  if (n < 0) { return []; }
  if (n === 0) { return [[]]; }
  if (n === 1) { return Data$dFunctor.arrayMap(Data$dArray.singleton)(a); }
  if (a.length === n) { return [a]; }
  if (a.length < n) { return []; }
  const v = Data$dArray.unconsImpl(v => Data$dMaybe.Nothing, x => xs => Data$dMaybe.$Maybe("Just", {head: x, tail: xs}), a);
  if (v.tag === "Just") {
    const $0 = v._1.head;
    return [...Data$dFunctor.arrayMap(v1 => [$0, ...v1])(combinations(n - 1 | 0)(v._1.tail)), ...combinations(n)(v._1.tail)];
  }
  return [];
};
const combinationNumber = /* #__PURE__ */ (() => {
  const pascalTriangle = Data$dList$dLazy.iterate(prev => Data$dArray.zipWithImpl(
    Data$dBigInt.biAdd,
    [Data$dBigInt.semiringBigInt.one, ...prev],
    Data$dBigInt.odd(prev[0]) ? [...prev, prev[prev.length - 1 | 0]] : prev
  ))([Data$dBigInt.fromInt(2)]);
  const go = go$a0$copy => go$a1$copy => {
    let go$a0 = go$a0$copy, go$a1 = go$a1$copy, go$c = true, go$r;
    while (go$c) {
      const v = go$a0, v1 = go$a1;
      if (v1 < 0 || v < v1) {
        go$c = false;
        go$r = Data$dBigInt.semiringBigInt.zero;
        continue;
      }
      if ((v - v1 | 0) < v1) {
        go$a0 = v;
        go$a1 = v - v1 | 0;
        continue;
      }
      if (v1 === 0) {
        go$c = false;
        go$r = Data$dBigInt.semiringBigInt.one;
        continue;
      }
      if (v1 === 1) {
        go$c = false;
        go$r = Data$dBigInt.fromInt(v);
        continue;
      }
      const $0 = Data$dList$dLazy.index(pascalTriangle)(v - 2 | 0);
      const $1 = v1 - 1 | 0;
      if ($0.tag === "Just") {
        if ($1 >= 0 && $1 < $0._1.length) {
          go$c = false;
          go$r = $0._1[$1];
          continue;
        }
        go$c = false;
        go$r = Data$dBigInt.semiringBigInt.zero;
        continue;
      }
      if ($0.tag === "Nothing") {
        go$c = false;
        go$r = Data$dBigInt.semiringBigInt.zero;
        continue;
      }
      $runtime.fail();
    }
    return go$r;
  };
  return go;
})();
export {combinationNumber, combinations, sumBy};
